var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2872",
    "data-name": "Group 2872",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.656,
    height: 19.656,
    viewBox: "0 0 19.656 19.656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    "data-name": "Path 1984",
    d: "M0,0H19.656V19.656H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1985",
    "data-name": "Path 1985",
    d: "M16.243,3.161,17.4,4.319,15.373,6.346,17.4,8.373,15.373,10.4,17.4,12.428l-2.027,2.027L17.4,16.482,16.242,17.64l-3.185-3.186,2.027-2.026L13.057,10.4l2.027-2.027L13.057,6.346l3.186-3.185Zm-5.326.473a.41.41,0,0,1,.093.259V16.907a.41.41,0,0,1-.669.317L6,13.676H2.819A.819.819,0,0,1,2,12.857V7.943a.819.819,0,0,1,.819-.819H6L10.34,3.576a.41.41,0,0,1,.577.057ZM9.371,6.485,6.589,8.761H3.638v3.277H6.589l2.782,2.277Z",
    transform: "translate(-0.362 -0.572)",
    fill: "#f5ca3d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferYellow);
export default __webpack_public_path__ + "static/media/refer-yellow.cd1520b6bdc6c6821f73bab12e8721e9.svg";
export { ForwardRef as ReactComponent };